import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8129d42d-fed9-4788-882a-4169a0f332c3/artifacts/jb8ymdb6_image.png";

export default function LoadingScreen({ onFinish }) {
  const { t } = useLanguage();
  const [show, setShow] = useState(true);

  useEffect(() => {
    document.body.classList.add("no-scroll");
    const timer = setTimeout(() => {
      setShow(false);
      document.body.classList.remove("no-scroll");
      setTimeout(() => onFinish && onFinish(), 800);
    }, 2500);
    return () => {
      clearTimeout(timer);
      document.body.classList.remove("no-scroll");
    };
  }, [onFinish]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="loading-screen"
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0a0a0a]"
        >
          {/* Decorative gold pulse ring */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="w-[520px] h-[520px] rounded-full opacity-20 blur-3xl bg-[radial-gradient(circle,#d4af37_0%,transparent_60%)]" />
          </div>

          <motion.div
            initial={{ scale: 0.8, opacity: 0, filter: "blur(10px)" }}
            animate={{ scale: 1, opacity: 1, filter: "blur(0px)" }}
            transition={{ duration: 1.1, ease: "easeOut" }}
            className="relative z-10"
          >
            <img
              src={LOGO_URL}
              alt="Lopez Appliances"
              className="w-44 sm:w-56 md:w-64 select-none"
              draggable={false}
            />
          </motion.div>

          <motion.p
            data-testid="loading-slogan"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.7, ease: "easeOut" }}
            className="font-serif-display italic text-base md:text-lg mt-6 px-6 text-center gold-shimmer"
          >
            {t("loading.slogan")}
          </motion.p>

          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 2.2, ease: "easeInOut" }}
            className="mt-10 h-[1px] w-48 origin-left bg-gradient-to-r from-transparent via-[#d4af37] to-transparent"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
